/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface Marketplace {
  id: number;
  header: string;
  code: string;
  pos: number;
  createdAt: Date;
  updatedAt: Date | null;
  enabled: boolean;
  deleted?: boolean;
}
